import { AstraCallout, AstraParagraph } from '~/astra'
import env from '~/env'

export const StagingBanner = () => (
    <AstraCallout
        color="caution"
        text={
            <AstraParagraph>
                You are currently viewing the <strong>staging</strong> environment for the <strong>{env.VITE_TENANT_NAME}</strong> tenant 🚧
            </AstraParagraph>
        }
    />
)
